import React from 'react'
import { _ } from 'utils'
import TextField from 'features/forms/components/TextField'
import FileUpload, { IMAGE_ONLY } from 'features/forms/components/FileUpload'

const Settings = () => (
    <>
        <TextField
            label={_('meeting_space.form.name')}
            name="parent.name"
            lg={1/2}
        />
        <FileUpload
            label={_('meeting_space.form.background_image')}
            name="parent.image"
            placeholder={_('meeting_space.form.background_image_placeholder')}
            lg={1/2}
            accept={IMAGE_ONLY}
        />
    </>
)

export default Settings
